import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ITheater } from "types/theater";

interface IYoutubeSettings {
  connectedYoutube: boolean;
  youtubeStatus: string;
}

export type TheaterState = {
  currentTheater: ITheater | null;
  theaterSpaces: string[];
  isInHostOnboarding: boolean;
  youtubeSettings: {
    connectedYoutube: boolean;
    youtubeStatus: string;
  };
};

export const initialState: TheaterState = {
  currentTheater: null,
  theaterSpaces: [],
  isInHostOnboarding: false,
  youtubeSettings: {
    connectedYoutube: false,
    youtubeStatus: "disconnected",
  },
};

export const theaterSlice = createSlice({
  name: "theater",
  initialState,
  reducers: {
    setCurrentTheater: (state, action: PayloadAction<ITheater>) => {
      state.currentTheater = action.payload;
    },
    setTheaterSpaces: (state, action: PayloadAction<string[]>) => {
      state.theaterSpaces = action.payload;
    },
    setTheaterYoutubeSettings: (
      state,
      action: PayloadAction<IYoutubeSettings>,
    ) => {
      state.youtubeSettings = action.payload;
    },
    setIsInHostOnboarding: (state, action: PayloadAction<boolean>) => {
      state.isInHostOnboarding = action.payload;
    },
    resetTheater: () => initialState,
  },
});

export const {
  setCurrentTheater,
  setTheaterSpaces,
  setTheaterYoutubeSettings,
  resetTheater,
  setIsInHostOnboarding,
} = theaterSlice.actions;

export default theaterSlice.reducer;
